export default "__VITE_ASSET__RfAQ4Ak7__"